import { render } from "./CustomerOrder.vue?vue&type=template&id=4acc899b&ts=true"
import script from "./CustomerOrder.vue?vue&type=script&lang=ts"
export * from "./CustomerOrder.vue?vue&type=script&lang=ts"

import "./CustomerOrder.vue?vue&type=style&index=0&id=4acc899b&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__